import FlexMasonry from 'flexmasonry/src/flexmasonry.js';

const startMasonry = () => {
  FlexMasonry.init('.grid', {
    responsive: true,
    breakpointCols: {
      'min-width: 1500px': 3,
      'min-width: 1200px': 3,
      'min-width: 992px': 3,
      'min-width: 768px': 2,
      'min-width: 576px': 1,
    },
    numCols: 5,
  });
  // eslint-disable-next-line no-undef
  $('.gallery').magnificPopup({
    delegate: '.gallery-link',
    gallery: {
      enabled: true, // set to true to enable gallery

      preload: [0, 2], // read about this option in next Lazy-loading section

      navigateByImgClick: true,

      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button

      tPrev: 'Previous (Left arrow key)', // title for left button
      tNext: 'Next (Right arrow key)', // title for right button
    },
    image: {
      markup: '<div class="mfp-figure">'
        + '<div class="mfp-close"></div>'
        + '<div class="mfp-img"></div>'
        + '<div class="mfp-bottom-bar">'
        + '<div class="mfp-title">by Marsel Van Oosten</div>'
        + '<div class="mfp-counter"></div>'
        + '</div>'
        + '</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button
    },
  });
};
export default startMasonry;
